import { Component, OnInit } from '@angular/core';
import { KalendarNeradnihDana } from './kalendar-neradnih-dana';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-kalendar-neradnih-dana-update',
  templateUrl: './kalendar-neradnih-dana-update.component.html'
})
export class KalendarNeradnihDanaUpdateComponent extends BaseUpdateComponent<KalendarNeradnihDana> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
  }

}
